var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashimg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.213 5.367l-1.26-.42.594-1.187A.667.667 0 0 0 12.42 3L11 1.58a.666.666 0 0 0-.767-.127l-1.186.594-.42-1.26A.667.667 0 0 0 8 .333H6a.667.667 0 0 0-.633.454l-.42 1.26-1.187-.594A.667.667 0 0 0 3 1.58L1.58 3a.667.667 0 0 0-.127.767l.594 1.186-1.26.42A.667.667 0 0 0 .333 6v2a.667.667 0 0 0 .454.633l1.26.42-.594 1.187a.667.667 0 0 0 .127.76L3 12.42a.667.667 0 0 0 .767.127l1.186-.594.42 1.26a.666.666 0 0 0 .634.454h2a.667.667 0 0 0 .633-.454l.42-1.26 1.187.594A.667.667 0 0 0 11 12.42L12.42 11a.666.666 0 0 0 .127-.767l-.594-1.186 1.26-.42A.667.667 0 0 0 13.667 8V6a.667.667 0 0 0-.454-.633zm-.88 2.153l-.8.267a1.333 1.333 0 0 0-.773 1.88l.38.76-.733.733-.74-.4a1.333 1.333 0 0 0-1.86.773l-.267.8H6.48l-.267-.8a1.333 1.333 0 0 0-1.88-.773l-.76.38-.733-.733.4-.74a1.333 1.333 0 0 0-.773-1.88l-.8-.267V6.48l.8-.267a1.333 1.333 0 0 0 .773-1.88l-.38-.74.733-.733.74.38a1.333 1.333 0 0 0 1.88-.773l.267-.8h1.04l.267.8a1.333 1.333 0 0 0 1.88.773l.76-.38.733.733-.4.74a1.333 1.333 0 0 0 .773 1.86l.8.267v1.06zM7 4.333a2.667 2.667 0 1 0 0 5.334 2.667 2.667 0 0 0 0-5.334zm0 4a1.333 1.333 0 1 1 0-2.667 1.333 1.333 0 0 1 0 2.667z",
    fill: "#696871"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashimg4);
export default __webpack_public_path__ + "static/media/dashimg4.91e1ee91.svg";
export { ForwardRef as ReactComponent };